import { render, staticRenderFns } from "./ModuleRejectionReason.vue?vue&type=template&id=a17708b4&"
import script from "./ModuleRejectionReason.vue?vue&type=script&lang=js&"
export * from "./ModuleRejectionReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports